(function () {
  var overlay = document.querySelector('.itk-share-overlay');
  if (!overlay) return;

  var urlEl = overlay.querySelector('[data-itk-share-url]');
  var url = urlEl ? urlEl.getAttribute('data-itk-share-url') : location.href;
  var toastEl = document.querySelector('.itk-share-toast');

  if (navigator.share) {
    var native = overlay.querySelector('.itk-share-item--native');
    if (native) native.hidden = false;
  }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._h);
    toastEl._h = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }

  function open() {
    overlay.hidden = false;
    document.body.classList.add('itk-share-lock');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    var c = overlay.querySelector('.itk-share-close');
    if (c) c.focus();
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('itk-share-lock');
    setTimeout(function () { overlay.hidden = true; }, 300);
  }

  function copy() {
    var done = function () {
      var b = overlay.querySelector('.itk-share-copy');
      if (b) {
        b.textContent = 'Link copied';
        b.classList.add('is-done');
        setTimeout(function () { b.textContent = 'Copy Link'; b.classList.remove('is-done'); }, 1800);
      }
      toast('Link copied');
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done).catch(function () { toast('Copy failed'); });
      return;
    }
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); done(); } catch (e) { toast('Copy failed'); }
    document.body.removeChild(ta);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-itk-share-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-itk-share-close]')) { close(); return; }
    if (e.target === overlay) { close(); return; }
    if (e.target.closest('[data-itk-share-copy]')) { copy(); return; }
    if (e.target.closest('[data-itk-share-instagram]')) {
      copy();
      toast('Link copied — paste it in Instagram');
      window.open('https://www.instagram.com/', '_blank', 'noopener');
      return;
    }
    if (e.target.closest('[data-itk-share-native]')) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });
})();